import Axios, {AxiosInstance} from 'axios';
import store from '../../service/store/index';
import { getBackend } from '../../service/router/getters';
import router from "../../service/router";
import { loginByToken } from '../helpers/relogin';
import { getBaseUrl } from '../helpers/url/baseUrl';
import { EventBus } from "@common/EventBus";

let isRefreshing = false;
let isWrongRefreshToken = false;
let subscribers: any[] = [];

const addSubscriber = (callback: any) => {
    subscribers.push(callback);
}

const onTokenFetched = (isRefreshed: boolean) => {
    subscribers.forEach((callback: any) => callback(isRefreshed));
    subscribers = [];
    isRefreshing = false;
    store.commit('setIsTokenUpdating', false);
}

const client: AxiosInstance = Axios.create({
    timeout: 20000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*"
    }
});

const refreshToken = (baseUrl?: string | undefined) => {
    if (!baseUrl) {
        baseUrl = getBaseUrl();
    }

    const lastRefreshDate = store.getters.localStorageSession().lastRefreshDate;

    //пропускаем получение нового токена в течении 30 секунд с последнего обновления
    if (lastRefreshDate && +lastRefreshDate + 30 * 1000 > Date.now()) {
        isRefreshing = false;
        store.dispatch("setSessionFromLocalStorage");
        EventBus.$emit('session/tokenUpdated');
        return;
    }

    return loginByToken(baseUrl, store.state.session.refreshToken)
        .then((result: any) => {
            store.dispatch('setNewCredentials', {
                sessionId: result.sessionId,
                refreshToken: result.refreshToken,
                lastRefreshDate: Date.now().toString()
            });
            onTokenFetched(true);
            EventBus.$emit('session/tokenUpdated');
            store.commit('setIsTokenUpdating', false);
        })
        .catch(async () => {
            onTokenFetched(false);
            isWrongRefreshToken = true;
            const backend = getBackend() || (client as any)._backend;
            store.commit('setIsTokenUpdating', false);
            await store.dispatch('resetSession', backend);
            router.push({name: 'Login', params: {backend: backend}});
        });
}

//@todo check if it is really unnecessary
(client as any).getToken = () => {
    return store.state.session?.sessionId;
}

(client as any).checkIsWrongRefreshToken = () => {
    return isWrongRefreshToken;
}

(client as any).setIsWrongRefreshToken = (value: boolean) => {
    isWrongRefreshToken = value;
}

client.interceptors.request.use(
    config => {
        const backendCode = store.state.session.backend || getBackend();
        config.baseURL = getBaseUrl(backendCode);

        if (store.state.session.sessionId) {
            config.headers["X-Appercode-Session-Token"] = store.state.session?.sessionId;
            const lang = store.state.session?.language ?? 'en';
            const langHeaderValue = config.headers["X-Appercode-Language"];

            /* prevent lang overwrite */
            if (!langHeaderValue) {
                config.headers["X-Appercode-Language"] = lang;
            }
        }
        (client as any)._backend = backendCode;
        (config as any)._backend = backendCode;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

client.refreshToken = function () {
    if (!isRefreshing) {
        isRefreshing = true;
        store.commit('setIsTokenUpdating', true);
        refreshToken();
    }

    return new Promise((resolve, reject) => {
        addSubscriber((isRefreshed: boolean) => {
            if (isRefreshed) {
                resolve();
            }
            else {
                reject();
            }
        })
    })
}

client.interceptors.response.use(config => {
    return config;
}, error => {
    if (error.response !== undefined) {
        if (error.response.status === 401 && error.response.config.url != 'login') {
            if (!isRefreshing) {
                isRefreshing = true;
                refreshToken(error.config.baseURL);
            }

            return new Promise((resolve, reject) => {
                addSubscriber((isRefreshed: boolean) => {
                    if (isRefreshed) {
                        const req = error.config;
                        req.headers["X-Appercode-Session-Token"] = store.state.session?.sessionId;
                        resolve(client(req));
                    }
                    else {
                        reject(error);
                    }
                })
            })
        }
    }
    return Promise.reject(error);
})

export { client }
